export const enum Role {
    ADMIN = 'br_admin',
    BR_HR = 'br_hr',
    ZOLTAN = 'zoltan',
    UGYINTEZO = 'ugyintezo',
    VEZENYLO = 'vezenylo',
    DOLGOZO_HR = 'dolgozo_hr',
    DOLGOZO_MUSZAKVEZ = 'dolgozo_muszakvez',
}

export type User = {
    username: string;
    name: string;
    email: string;
    roles: [Role];
    accessToken: string | null;
    refreshToken: string | null;
    exp: number;
    workplace?: string;
};

export type RealmAttribute = {
    roles: [Role];
};

export type AuthPayload = {
    preferred_username: string;
    name: string;
    email: string;
    iat: number;
    exp: number;
    family_name: string;
    given_name: string;
    realm_access: RealmAttribute;
    workplace?: string;
};

export type AuthContextType = {
    user: User | undefined;
    isAuthenticated: boolean;
    signOut: () => void;
    signIn: (accessToken: string, refreshToken: string) => void;
    setAuthToken: (token: string) => void;
    setRefreshToken: (token: string) => void;
};
